import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { PopupState } from '../../shared/popup/popup';

@Injectable({
	providedIn: 'root'
})
export class PopupService {
	private popupSubject = new Subject<PopupState>();
	popupState = this.popupSubject.asObservable();

	constructor() {
	}

	show(title: string, description: string, hideX = false, params?, textButton?: string, arrayDocs?: any[], codiceTipoDoc?: string) {
		this.popupSubject.next(<PopupState>{
			isVisible: true,
			title,
			description,
			hideX,
			params,
			textButton,
			arrayDocs,
			codiceTipoDoc
		});
	}

	hide() {
		this.popupSubject.next(<PopupState>{ isVisible: false });
	}
}
